













































































































































import { defineComponent } from '@vue/composition-api'
import { AsYouType } from 'libphonenumber-js'
import { getBalanceTopUp, getProducts } from '~/api/Topup/topup.api'
import { getUsers } from '~/api/Users/users.api'
import AppView from '~/components/AppView.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import ConfirmDialog from '~/components/ConfirmDialog.vue'
import IconButton from '~/components/IconButton.vue'
import RangeDatePicker from '~/components/RangeDatePicker.vue'
import AssignBalanceTopUpButton from '~/components/Services/TopUps/AssignBalanceTopUpButton.vue'
import ConfirmBalanceTopUpButton from '~/components/Services/TopUps/ConfirmBalanceTopUpButton.vue'
import UserListItem from '~/components/UserListItem.vue'
import { chipClasses } from '~/utils/chipClasses.constant'
import { formatDate } from '~/utils/functions'
import { DatePicker, Params } from '~/utils/interfaces'
import { Remittance } from '~/utils/interfaces/remittance.interface'
import { GetTopUpDTO } from '~/utils/interfaces/topup.interface'
import { topUpStatus } from '~/utils/topUpStatus.constant'

export default defineComponent({
  components: {
    AppView,
    ConfirmBalanceTopUpButton,
    IconButton,
    AssignBalanceTopUpButton,
    RangeDatePicker,
    Autocomplete,
    UserListItem,
    ConfirmDialog,
  },
  setup() {
    return {
      getBalanceTopUp,
      formatDate,
      asYouType(value: string) {
        return new AsYouType().input(value)
      },
      chipClasses,
    }
  },
  data() {
    return {
      status: topUpStatus.map(status => ({
        value: status,
        text: this.$t(status),
      })),
      headers: [
        {
          text: this.$t('agency.agency'),
          value: 'from_agency_name',
          notShow: !this.$p.isAdmin,
        },
        {
          text: this.$t('client-name'),
          value: 'client',
        },
        {
          text: this.$t('number'),
          value: 'phone_number',
        },
        {
          text: this.$t('agent'),
          value: 'from_agent_name',
        },
        {
          text: this.$t('assigned_to'),
          value: 'assigned_to_name',
        },
        {
          text: this.$t('amount') + ' ($)',
          value: 'amount',
        },
        {
          text: this.$t('created-at'),
          value: 'created_at',
        },
        {
          text: this.$t('status'),
          value: 'status',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
      lastSelected: '',
    }
  },
  methods: {
    getAgents: (params?: Params) =>
      getUsers({ ...params, services__name: 'TOP-UP' }),
    getProducts,
    serializeFilter(filter: Iterable<unknown>) {
      const dates = (this.$refs.datePicker as DatePicker).getData()
      return {
        ...filter,
        topup__created_at__gte: dates.minDate,
        topup__created_at__lte: dates.maxDate,
      } as { [key: string]: any }
    },
    itemClass(item: Remittance) {
      if (item.uuid === this.lastSelected) return 'cyan lighten-4'
      return ''
    },
    onClickRow(event: Remittance) {
      this.lastSelected = event.uuid
    },
    onCopyItem(item: GetTopUpDTO) {
      let phone_number = item.phone_number || item.destination_account
      phone_number = phone_number?.startsWith('53')
        ? phone_number.replace('53', '')
        : phone_number
      if (phone_number) {
        navigator.clipboard.writeText(
          phone_number + ' - ' + item.destination_amount,
        )
        this.$toast.success(this.$t('phone_number_copied'))
      }
    },
  },
})
